<div class="steps-container">
  <div class="steps-row" [attr.data-step-count]="steps?.length || 0">
    @for (step of steps; track step.id; let index = $index){
      <div class="step"
        #stepElement
        (click)="changeStep(index)"
        (mouseenter)="onStepHover(index)"
        (mouseleave)="onStepLeave()"
        [matTooltip]="getStepTooltip(step)"
        matTooltipPosition="above"
        [matTooltipShowDelay]="300"
        [ngClass]="{
          'lost-step': isLost,
          'active-step': !isLost && !step.futureStep && !step.isOverdue,
          'overdue-step': !isLost && !step.futureStep && step.isOverdue,
          'futureStep': !isLost && step.futureStep,
          'hovered': hoveredIndex === index,
          'near-hovered': isNearHovered(index),
          'far-from-hover': isFarFromHover(index)
        }">
        <span class="step-text">{{step.name}}</span>
      </div>
    }
  </div>
  <div class="bottom-step">
    <div class="step-info-left">
      @if(steps?.length){
        <span class="current-step-info" *ngIf="steps?.[currentStepIndex]">
          Current Step: <b>{{ steps[currentStepIndex]?.name | titlecase }}</b>
        </span>
      }
      
      <!-- Divider -->
      <span class="info-divider" *ngIf="steps?.length && (leadTags()?.length || unassignedTags.length > 0)">|</span>
      
      <!-- Tags Section -->
      <div class="tags-section" *ngIf="leadTags()?.length || unassignedTags.length > 0">
        <span class="tags-label">Labels:</span>
        <div class="tags-container">
          @for (leadTag of leadTags(); track leadTag.tag_id || leadTag.tag?.id) {
            <span class="tag-chip" 
                  [style.background-color]="leadTag.tag?.color || '#6b7280'">
              {{ leadTag.tag?.name }}
              <span class="tag-remove" (click)="removeTag(leadTag, $event)">×</span>
            </span>
          }
          
          <!-- Add tag button -->
          <div class="add-tag-wrapper" *ngIf="unassignedTags.length > 0">
            <button class="add-tag-btn" (click)="toggleTagDropdown($event)">
              <mat-icon>add</mat-icon>
            </button>
            
            <!-- Dropdown -->
            <div class="tag-dropdown" *ngIf="showTagDropdown">
              @for (tag of unassignedTags; track tag.id) {
                <div class="tag-option" (click)="addTag(tag)">
                  <span class="tag-color-dot" [style.background-color]="tag.color"></span>
                  {{ tag.name }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="admission-wrapper" *ngIf="isEnrolledState()">
      <span class="admission-badge" [ngClass]="getAdmissionBadgeClass()">
        {{ getAdmissionLabel() }}
      </span>
    </div>
  </div>
</div>